import { Component, OnInit } from '@angular/core';
import {Subject} from 'rxjs';
import {Input, OnDestroy, Output} from '@node_modules/@angular/core';
import {Program} from '@models/program';
import {Class} from '@models/class';
import * as moment from 'moment';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {ProgramScheduleComponent} from '@pages/layout/program/program-page/program-schedule/program-schedule.component';

@Component({
  selector: 'app-program-schedule-month',
  templateUrl: './program-schedule-month.component.html',
  styleUrls: ['./program-schedule-month.component.scss']
})
export class ProgramScheduleMonthComponent implements OnInit,OnDestroy {
  @Input() program: Program;
  @Input() programs: Program[];
  @Input() onToday: Subject<any>;
  @Input() onLeft: Subject<any>;
  @Input() onRight: Subject<any>;
  @Output() currentDay: Subject<Class> = new BehaviorSubject(null);
  classesByMonth = {};
  selectedDay;
  sortedMonthWithClasses = [];
  currentMonth = moment();
  currentYear = moment();
  week = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  subscribes = [];

  constructor() { }

  ngOnInit() {
    this.getMonth();
    this.subscribes.push(this.onToday.subscribe(
      (resp: any) => {
        // console.log(resp);
        if (resp) {
          this.currentMonth = moment();
          this.getMonth();
        }
      }
    ));
    this.subscribes.push(this.onLeft.subscribe(
      (resp: any) => {
        // console.log(resp);
        if (resp && resp === 'month') {
          this.currentMonth.add(-1, 'month');
          this.currentYear = this.currentMonth.clone();
          // if (resp === 'month') {
          //   this.currentMonth.add(-1, 'month');
          // }
          // if (resp === 'week') {
          //   this.currentMonth.add(-1, 'week');
          // }
          this.getMonth();
        }
      }
    ));
    this.subscribes.push(this.onRight.subscribe(
      (resp: any) => {
        // console.log(resp);
        if (resp && resp === 'month') {
          this.currentMonth.add(1, 'month');
          this.currentYear = this.currentMonth.clone();
          // if (resp === 'month') {
          //   this.currentMonth.add(1, 'month');
          // }
          // if (resp === 'week') {
          //   this.currentMonth.add(1, 'week');
          // }          this.getMonth();
        }
      }
    ));
    document.getElementsByClassName('program-schedule').item(0).addEventListener('click', () => {
      this.selectedDay = null;
    });
    this.onToday.next(true);
  }

  getMonth() {
    this.selectedDay = null;
    const startWeekDay = this.currentMonth.clone().startOf('month').day();
    this.setClassesByMonth(this.currentMonth);
    this.sortedMonthWithClasses = startWeekDay > 0 ? new Array(startWeekDay - 1).fill(0) : [];
    new Array(this.currentMonth.daysInMonth()).fill(0).map( (day, i) => {
      const classes = this.getStoredClassByMonth(i);
      this.sortedMonthWithClasses.push({length: this.getAllClasses(classes).length, classes: classes, dayNumber: i + 1, cssClass:   (i+1) * 12 + 'monthsCr'});
    });
  }
  getAllClasses(classes) {
    let classesArray = [];
    Object.keys(classes).map( item => {
      classes[item].map( classc => classesArray.push(classc));
    });
    return classesArray;
  }
  getStoredClassByMonth(dayNumber) {
    const currentDay = this.currentMonth.clone().startOf('month').add(dayNumber , 'days');
    const date = currentDay.format('MMM Do YY');
    if (this.classesByMonth[date] && this.classesByMonth[date][+this.getDayNumber(currentDay)]) {
      return this.classesByMonth[date][+this.getDayNumber(currentDay)];
    }
    return [];
  }
  setClassesByMonth(month, from: number = 1) {
    this.classesByMonth = {};
    new Array(month.daysInMonth()).fill(1).map( (day, i) => {
      if (i + 1 >= from) {
        const currentDay = month.clone().startOf('month').add(i, 'days');
        this.classesByMonth = ProgramScheduleComponent.getClassByDate(this.program, this.programs, currentDay, this.classesByMonth, false);
        // this.setScheduleByDay(currentDay, schedule, item);
      }
    });
    // const classes = [].concat(...this.programs.map(progr => progr.classes));
    // classes.map( (item: Class) => {
    //   item.schedule.map( schedule => {
    //     new Array(month.daysInMonth()).fill(1).map( (day, i) => {
    //       if (i + 1 >= from) {
    //         const currentDay = month.clone().startOf('month').add(i, 'days');
    //         this.setScheduleByDay(currentDay, schedule, item);
    //       }
    //     });
    //   });
    // });
  }
  getDayNumber(day) {
    return moment(day).date();
  }
  getMonthNumber(day) {
    return moment(day).month() + 1;
  }
  showModal(event, day) {
    // console.log(day);
    let elem = event.target;
    if (!elem.classList.contains('program-schedule-content-month-calendar-body-item')) {
      elem = event.target.closest('.program-schedule-content-month-calendar-body-item');
    }
    let popup = elem.getElementsByClassName('popup-with-day-hidden').item(0);
    if (popup) {
      this.selectedDay = day;
      event.stopPropagation();
      let rectangle = popup.getBoundingClientRect() as { x: number, y: number };
      if (+(document.documentElement.offsetWidth / rectangle.x).toFixed(2) < 1.7) {
        popup.style.marginLeft = '-378px';
        day.cssClass = 'triangle-to-right';
        rectangle = popup.getBoundingClientRect() as { x: number, y: number };
      } else {
        day.cssClass = 'triangle-to-left';
        rectangle = popup.getBoundingClientRect() as { x: number, y: number };
      }
      day.styles = {
        top: (rectangle.y + document.documentElement.scrollTop) + 'px',
        left: rectangle.x + 'px',
      };
      day.month = this.currentMonth.format('MMMM');
      this.currentDay.next(day);
      popup.style.marginLeft = '';
    }
  }
  // setScheduleByDay(day, schedule: Schedule, classc: Class) {
  //   let classcLocal = Object.assign({}, classc);
  //   let scheduleChecked;
  //   switch (schedule.repeat_time) {
  //     case 'day':
  //       scheduleChecked = schedule;
  //       break;
  //     case 'week':
  //       if (schedule.dayName === day.format('dddd').substring(0, 3).toLowerCase()) {
  //         scheduleChecked = schedule;
  //       }
  //       break;
  //     case 'month':
  //       if (+schedule.day === +this.getDayNumber(day)) {
  //         scheduleChecked = schedule;
  //       }
  //       break;
  //     case 'none':
  //       if (+schedule.day === +this.getDayNumber(day)
  //         && +schedule.month === +this.getMonthNumber(day)
  //         && +schedule.year === day.year()) {
  //         scheduleChecked = schedule;
  //       }
  //       break;
  //   }
  //   if (scheduleChecked) {
  //     const date = day.format('MMM Do YY');
  //     if (!this.classesByMonth[date]) {
  //       this.classesByMonth[date] = {};
  //       this.classesByMonth[date][+this.getDayNumber(day)] = {};
  //     }
  //     classcLocal.program_id = scheduleChecked.program_id;
  //     classcLocal.schedule = scheduleChecked;
  //     classcLocal.cssClass = Math.random().toString(36).substr(2, 9);
  //     if (!this.classesByMonth[date][+this.getDayNumber(day)][classcLocal.id]) {
  //       this.classesByMonth[date][+this.getDayNumber(day)][classcLocal.id] = [];
  //       this.classesByMonth[date][+this.getDayNumber(day)][classcLocal.id].push(classcLocal);
  //     }
  //   }
  // }
  isToday(dayNumber) {
    return moment().date() === dayNumber && moment().month() === this.currentMonth.month();
  }
  isTheSameWeekDay(weekDay) {
    return  this.currentMonth.format('dddd').substring(0, 3).toLowerCase() === weekDay.toLowerCase()
      && moment().month() === this.currentMonth.month();
  }
  isProgramsSchedule(day) {
    let found = false;
    if (day.classes) {
      Object.keys(day.classes).map( item => {
        day.classes[item].map( classc => {
          if (classc.program_id === this.program.id) {
            found = true;
          }
        })
      });
    }
    return found;
  }
  ngOnDestroy() {
    this.subscribes.map( subscr => {
      subscr.unsubscribe();
    });
  }
}
